define('uikit/elements/help.text.icon',['require','exports','module','underscore','marionette','../mixins/component.mixin','templates','../behaviors/tooltip.behavior'],function(require, exports, module) {
  // prettier-ignore
  var _               = require('underscore'),
      Mn              = require('marionette'),
      ComponentMixin  = require('../mixins/component.mixin'),
      Templates       = require('templates'),
      TooltipBehavior = require('../behaviors/tooltip.behavior');

  var HelpTextIcon = Mn.ItemView.extend(ComponentMixin).extend({
    template: Templates.App['help.icon'],

    options: {
      helpText: '',
    },

    behaviors: function() {
      return {
        ShowHelpText: {
          behaviorClass: TooltipBehavior,
          content: this.getOption('helpText'),
        },
      };
    },
  });

  module.exports = HelpTextIcon;
});

